/**
 * @generated SignedSource<<e9f27c6777ea7497fbbef33890f7b40c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PieceRendererNoteChangeDuration_note$data = {
  readonly bulb_id: string;
  readonly note_duration: number;
  readonly " $fragmentType": "PieceRendererNoteChangeDuration_note";
};
export type PieceRendererNoteChangeDuration_note$key = {
  readonly " $data"?: PieceRendererNoteChangeDuration_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"PieceRendererNoteChangeDuration_note">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PieceRendererNoteChangeDuration_note",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bulb_id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "note_duration",
      "storageKey": null
    }
  ],
  "type": "MusicPieceFileNote",
  "abstractKey": null
};

(node as any).hash = "c8ced0c10b4419b268b0bde25fe83794";

export default node;
